export const COUNT_STATUS = {
  APPROVED: 'APPROVED',
  ACCEPTABLE: 'ACCEPTABLE',
  NEEDS_CORRECTION: 'NEEDS_CORRECTION',
  EMPTY: 'EMPTY'
} as const
